// extracted by css-extract-rspack-plugin
export default {"checkboxRow":"checkboxRow-Kkrv0o"};